import { render, staticRenderFns } from "./broadcast-schedule.vue?vue&type=template&id=0ad8fa5f"
import script from "./broadcast-schedule.vue?vue&type=script&lang=js"
export * from "./broadcast-schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports